import type { URL } from "@myloc/myloc-utils";
import { endpoint } from "../../../../config/settings";

export const api = {
  openid: {
    exchangeToken: (): URL => endpoint("/authentication/open-id/exchange-token"),
  },
};
